const SearchModalSection = ({children, title}) => {
    return (
        <div className="grid gap-[12px]">
            {title && <p className="text-[12px] custom-text-grey-900">{title}</p>}
            {children}
        </div> 
    );
}
export default SearchModalSection;